// Project brain (brain_pages / brain_links, mig 182) — Tarjeta Presente planet.

export const BRAIN_PROJECT_TP = 'tarjeta-presente'

export type BrainPageType = 'company' | 'person' | 'meeting' | 'deal' | 'note' | 'deck' | 'concept'
export type BrainSource = 'manual' | 'gong' | 'salesforce' | 'deck' | 'whatsapp' | 'agent' | 'fireflies' | 'slack'

// Equipos del proyecto (frontmatter.team, mig 202) — secciones del Cerebro
export type BrainTeam = 'comercial' | 'producto' | 'tecnologia' | 'seguridad' | 'legal'
export const BRAIN_TEAMS: BrainTeam[] = ['comercial', 'producto', 'tecnologia', 'seguridad', 'legal']
export const BRAIN_TEAM_LABELS: Record<BrainTeam, string> = {
  comercial: 'Comercial',
  producto: 'Producto',
  tecnologia: 'Tecnología',
  seguridad: 'Seguridad',
  legal: 'Legal',
}

export interface BrainPage {
  id: string
  org_id: string
  project: string
  slug: string
  page_type: BrainPageType
  title: string
  content_md: string
  frontmatter: Record<string, unknown>
  source: BrainSource
  source_ref: string | null
  created_by: string | null
  created_at: string
  updated_at: string
}

// List queries exclude content_md (payload weight)
export type BrainPageMeta = Omit<BrainPage, 'content_md'>

export interface BrainSearchHit {
  id: string
  slug: string
  page_type: BrainPageType
  title: string
  snippet: string
  score: number
  updated_at: string
}

export interface BrainWriteResponse {
  success: boolean
  id: string
  slug: string
  links_created: number
  embedded: boolean
}

export interface BrainAskSource {
  slug: string
  title: string
  page_type: BrainPageType
  score: number
  updated_at: string
}

export interface BrainAskResponse {
  success: boolean
  answer_md: string
  sources: BrainAskSource[]
  model: string | null
}

export interface BrainSyncResponse {
  success: boolean
  orgs: Array<Record<string, unknown>>
}

export const BRAIN_TYPE_LABELS: Record<BrainPageType, string> = {
  company: 'Cuenta',
  person: 'Persona',
  meeting: 'Llamada',
  deal: 'Oportunidad',
  note: 'Nota',
  deck: 'Deck',
  concept: 'Concepto',
}

export const BRAIN_TYPE_COLORS: Record<BrainPageType, string> = {
  company: 'bg-teal-500/15 text-teal-600 dark:text-teal-400',
  person: 'bg-violet-500/15 text-violet-600 dark:text-violet-400',
  meeting: 'bg-amber-500/15 text-amber-600 dark:text-amber-400',
  deal: 'bg-emerald-500/15 text-emerald-600 dark:text-emerald-400',
  note: 'bg-sky-500/15 text-sky-600 dark:text-sky-400',
  deck: 'bg-rose-500/15 text-rose-600 dark:text-rose-400',
  concept: 'bg-indigo-500/15 text-indigo-600 dark:text-indigo-400',
}
